import Logger from './Logger';
import getSourceMapLocation, { SourceMapLocation } from './getSourceMapLocation';

interface ErrorRequest {
    message: string;
    url: string;
    line: number;
    column: number;
    rUrl: string;
    errorString?: string;
    stacktrace?: SourceMapLocation;
}

const isNotMyFault = (errorEvent: ErrorEvent, contextPath: string) => errorEvent.filename.indexOf(contextPath) === -1;

const logErrorFromHandler = (logger: Logger, errorEvent: ErrorEvent, externalStackTrance?: SourceMapLocation) => {
    const { error } = errorEvent;
    const json: ErrorRequest = {
        message: errorEvent.message,
        url: errorEvent.filename,
        line: errorEvent.lineno,
        column: errorEvent.colno,
        rUrl: window.location.href,
        stacktrace: externalStackTrance,
        errorString: error?.stack ? error.stack : error,
    };

    logger.log('error', json);
};

export const createHandler = (logger: Logger, contextPath: string) => (errorEvent: ErrorEvent) => {
    if (isNotMyFault(errorEvent, contextPath)) {
        return;
    }

    logErrorFromHandler(logger, errorEvent);
};

export const createSourceMapHandler = (logger: Logger, namespace: string) => {
    const sourcMapChecker = getSourceMapLocation(namespace);
    return async (errorEvent: ErrorEvent) => {
        const sourceMap = await sourcMapChecker(
            errorEvent ? { componentStack: errorEvent.error?.stack ?? errorEvent.error } : undefined,
        );
        if (!sourceMap?.stackError) {
            return;
        }

        logErrorFromHandler(logger, errorEvent, sourceMap);
    };
};
